<app-auth-header></app-auth-header>
<div class=" fixed bottom-0 w-full z-50">
  <app-footer></app-footer>
</div>
<div
  class="relative h-[94%] bg-cover bg-center text-white flex items-center justify-center ]"
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="absolute inset-0 bg-[#272c36] bg-opacity-60"></div>

  <div
    class="fixed z-50 flex justify-center w-[53.281vw] max-h-[72vh] bg-[#F1F3F5] rounded-[8px] mb-[90px]"
  >
    <div class="flex flex-col !items-center">
      <h1
        class="text-[#21252A] !text-[2rem] !ml-[25px] !font-Roboto !font-semibold leading-[2.4rem] tracking-[-0.96px] pt-[31px]"
      >
        Change Password
      </h1>

      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="w-[27vw] mr-[12.5rem] mt-[15px] ">
          <!-- OTP input -->
          <mat-form-field
            appearance="outline"
            class="flex items-center justify-between w-[100%] h-[55px]"
          >
            <mat-label> Enter OTP </mat-label>

            <input
              matInput
              id="otp"
              formControlName="otp"
              type="number"
              min="1"
              pattern="\d*"
              oninput="this.value = this.value.slice(0, 6);"
              class="w-full bg-[#F1F3F5] text-[#343A40] border-[1px] border-[#1A4971] pl-[17px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
              placeholder="Enter Your OTP"
            />
            <mat-error
            *ngIf="changePasswordForm.get('otp').hasError('required')"
          >
            OTP is required.
          </mat-error>
          </mat-form-field>
          <!-- New password -->
          <mat-form-field
            appearance="outline"
            class="flex items-center justify-between w-[100%] mt-[30px] h-[55px]"
          >
            <mat-label> Enter Your New Password </mat-label>

            <input
              matInput
              id="newpassword"
              formControlName="newpassword"
              [type]="viewPassword ? 'text' : 'password'"
              class="w-full bg-[#F1F3F5] text-[#343A40] border-[1px] border-[#1A4971] pl-[17px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
              placeholder="Enter Your New Password"
            />
            <mat-icon
                    matSuffix
                    class="text-[#FF6F00] !text-[20px]"
                    (click)="viewPassword = !viewPassword"
                    >{{ viewPassword ? "visibility" : "visibility_off" }}</mat-icon
                  >

            <mat-error
              *ngIf="changePasswordForm.get('newpassword').hasError('required')"
            >
              Password is required.
            </mat-error>
            <mat-error
          *ngIf="changePasswordForm.get('newpassword').hasError('minlength')"
        >
              The new Password must be at least 12 characters.
            </mat-error>
          </mat-form-field>

          <!-- confirm password -->
          <mat-form-field
            appearance="outline"
            class="flex items-center mt-[30px] justify-between w-[100%]"
          >
            <mat-label> Confirm Password </mat-label>

            <input
              matInput
              id="confirmpassword"
              formControlName="confirmpassword"
              [type]="viewPassword ? 'text' : 'password'"
              class="w-full bg-[#F1F3F5] text-[#343A40] border-[1px] border-[#1A4971] pl-[17px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
              placeholder="Confirm Password"
            />

            <mat-error
              *ngIf="changePasswordForm.get('confirmpassword').hasError('required')"
            >
              Confirm password is required.
            </mat-error>
            <mat-error *ngIf="changePasswordForm.hasError('passwordsDoNotMatch')">
              Passwords do not match.
            </mat-error>
          </mat-form-field>

          <div class="flex items-center justify-between w-[503px] mt-[30px]">
            <div></div>

           
          </div>
        </div>
        
      </form>
      <div class="w-[100%] flex  mt-[-25px] justify-end mb-[2.5rem] mr-[-90px]">
        <button
        (click)="navigateBack()"
          type="button"
          class="flex w-[114px] h-[48px] text-[1rem] !text-[#E76B3F] mr-[10px] roboto font-semibold hover:bg-[#fcfffd] p-[14px]  border border-[#E76B3F] justify-center items-center  rounded-[5px] bg-[#F1F3F5]"
        >
          Back
        </button>
        <button
        (click)="navigateTo()"
          type="button"
          class="flex w-[114px] text-[#F1F3F5] text-[1rem] shadow-custom h-[48px] roboto font-semibold  justify-center items-center  rounded-[5px] bg-[#E76B3F] "
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
